"use strict";

exports.__esModule = true;
exports.WixStyleReactMaskingContext = void 0;

var _wixDesignSystemsProviders = require("wix-design-systems-providers");

var WixStyleReactMaskingContext = _wixDesignSystemsProviders.WixDesignSystemsMaskingContext;
exports.WixStyleReactMaskingContext = WixStyleReactMaskingContext;
//# sourceMappingURL=context.js.map